import './CardList.scss';
import CardLoader from '../Card/CardLoader';

export default function CardList(): JSX.Element {
  return (
    <div className="m-slider-container">
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <CardLoader />
        </div>
      </div>
    </div>
  );
}
